module.exports = __webpack_public_path__ + "static/media/yantralive-new-banner2.7303d36f.png";